<button
  id="historyModalBtn"
  data-toggle="modal"
  data-target="#deviceHistory_modal"
  [hidden]="true">
  History Modal
</button>

<div data-keyboard="false" data-backdrop="static" id="deviceHistory_modal" class="modal fade dh-modal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content dh-modal__content">
      <div class="modal-body p-0">
        <div class="dh">
          <header class="dh__header">
            <div class="dh__title-wrap">
              <span class="dh__header-ico" aria-hidden="true">
                <i class="fa fa-history"></i>
              </span>
              <h5 class="dh__title">Device History</h5>
            </div>
            <button
              type="button"
              class="dh__close"
              id="closeHistoryModal"
              data-dismiss="modal"
              aria-label="Close"
              (click)="onClose()">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </header>

          <div class="dh__body">
            <section class="dh__summary">
              <div class="dh__summary-item">
                <span class="dh__summary-ico" aria-hidden="true">
                  <i class="fa fa-flash"></i>
                </span>
                <div class="dh__summary-text">
                  <span class="dh__summary-label">Campaign Name</span>
                  <span class="dh__summary-value" [title]="campaignName">{{ campaignName }}</span>
                </div>
              </div>
              <div class="dh__summary-item">
                <span class="dh__summary-ico" aria-hidden="true">
                  <i class="fa fa-microchip"></i>
                </span>
                <div class="dh__summary-text">
                  <span class="dh__summary-label">Serial Number</span>
                  <span class="dh__summary-value" [title]="$safeNavigationMigration(device?.serialNumber)">{{ device?.serialNumber }}</span>
                </div>
              </div>
              <div class="dh__summary-item dh__summary-item--actions">
                <span class="dh__summary-ico" aria-hidden="true">
                  <i class="fa fa-repeat"></i>
                </span>
                <div class="dh__summary-text">
                  <span class="dh__summary-label">Trigger Count</span>
                  <span class="dh__summary-value">{{ deviceHistory.length }}</span>
                </div>
                <button
                  type="button"
                  class="dh__export-btn"
                  ngbTooltip="Export CSV"
                  placement="top"
                  container="body"
                  [disabled]="!deviceHistory.length"
                  (click)="exportActivityCSV()"
                  aria-label="Export CSV">
                  <i class="fa fa-cloud-download" aria-hidden="true"></i>
                </button>
              </div>
            </section>

            @if (isLoading) {
              <div class="dh__loading">
                <div class="dh__spinner" aria-hidden="true"></div>
                <span>Loading history…</span>
              </div>
            }

            @if (!isLoading && deviceHistoryView.length) {
              <div class="dh__list">
                @for (data of deviceHistoryView; track data) {
                  <article class="dh__entry">
                    <div class="dh__entry-meta">
                      @if (!campaignName?.endsWith('Config Update')) {
                        <span class="dh__stage-badge">Stage - {{ data.stage }}</span>
                      } @else {
                        <span></span>
                      }
                      <div class="dh__meta-right">
                        <span class="dh__meta-chip" ngbTooltip="Scheduled By">
                          <i class="fa fa-user" aria-hidden="true"></i>
                          <span>{{ data.scheduledBy }}</span>
                        </span>
                        <span class="dh__meta-chip" ngbTooltip="Processing Time">
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                          @if (data.totalTime) {
                            <span>{{ data.totalTime | secondsToHms: 'milliseconds' }}</span>
                          } @else {
                            <span>——</span>
                          }
                        </span>
                      </div>
                    </div>

                    <ul class="dh__timeline">
                      <li
                        class="dh__step"
                        [class.dh__step--scheduled]="data.status==='RETRY' || data.status==='SYSTEM_RETRY' || data.status==='SCHEDULED'"
                        [class.dh__step--commandSent]="data.status==='COMMAND_SENT'"
                        [class.dh__step--inProgress]="data.status==='PROGRESS'"
                        [class.dh__step--downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                        [class.dh__step--success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                        [class.dh__step--cancelled]="data.status==='CANCELLED'"
                        [class.dh__step--failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                        <div class="dh__step-label">
                          @if (data.status==='RETRY' || data.status==='SYSTEM_RETRY') {
                            <span>Retry</span>
                          } @else {
                            <span>Scheduled</span>
                          }
                        </div>
                        <div class="dh__step-dot"></div>
                        <div class="dh__step-time">
                          <span>{{ data.scheduleAt | date: dateFormat }}</span>
                        </div>
                      </li>

                      <li
                        class="dh__step"
                        [class.dh__step--commandSent]="data.status==='COMMAND_SENT'"
                        [class.dh__step--inProgress]="data.status==='PROGRESS'"
                        [class.dh__step--downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                        [class.dh__step--success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                        [class.dh__step--cancelled]="data.status==='CANCELLED'"
                        [class.dh__step--failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                        <div class="dh__step-label"><span>Command Sent</span></div>
                        <div class="dh__step-dot"></div>
                        @if (data.commandSentAt) {
                          <div class="dh__step-time">
                            <span>{{ data.commandSentAt | date: dateFormat }}</span>
                          </div>
                        }
                      </li>

                      <li
                        class="dh__step"
                        [class.dh__step--inProgress]="data.status==='PROGRESS'"
                        [class.dh__step--downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                        [class.dh__step--success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                        [class.dh__step--cancelled]="data.status==='CANCELLED'"
                        [class.dh__step--failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                        <div class="dh__step-label"><span>In Progress</span></div>
                        <div class="dh__step-dot"></div>
                        @if (data.progressAt) {
                          <div class="dh__step-time">
                            <span>{{ data.progressAt | date: dateFormat }}</span>
                          </div>
                        }
                      </li>

                      <li
                        class="dh__step"
                        [class.dh__step--downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                        [class.dh__step--success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                        [class.dh__step--cancelled]="data.status==='CANCELLED'"
                        [class.dh__step--failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                        <div class="dh__step-label"><span>Download Success</span></div>
                        <div class="dh__step-dot"></div>
                        @if (data.downloadSuccessAt) {
                          <div class="dh__step-time">
                            <span>{{ data.downloadSuccessAt | date: dateFormat }}</span>
                          </div>
                        }
                      </li>

                      <li
                        class="dh__step"
                        [class.dh__step--success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                        [class.dh__step--installSuccess]="data.status==='INSTALL_SUCCESS'"
                        [class.dh__step--cancelled]="data.status==='CANCELLED'"
                        [class.dh__step--failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                        <div class="dh__step-label">
                          <span>{{ data.status==='INSTALL_FAILED' ? 'Install Failed' : 'Install Success' }}</span>
                        </div>
                        <div
                          class="dh__step-dot"
                          [class.dh__step-dot--hover]="data.status==='INSTALL_SUCCESS' || data.status==='INSTALL_FAILED' || data.status==='TOO_MANY_ATTEMPT'"
                          [ngbTooltip]="tooltipContent(data)"
                          options="displayTooltip(data)">
                        </div>
                        @if (data.installSuccessAt && data.status==='INSTALL_SUCCESS') {
                          <div class="dh__step-time">
                            <span>{{ data.installSuccessAt | date: dateFormat }}</span>
                          </div>
                        }
                        @if (data.installFailedAt && data.status==='INSTALL_FAILED') {
                          <div class="dh__step-time">
                            <span>{{ data.installFailedAt | date: dateFormat }}</span>
                          </div>
                        }
                      </li>

                      <li
                        class="dh__step"
                        [class.dh__step--success]="data.status==='SUCCESS'"
                        [class.dh__step--cancelled]="data.status==='CANCELLED'"
                        [class.dh__step--failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT'">
                        <div class="dh__step-label">
                          @if (data.status==='SUCCESS') {
                            <span>Success</span>
                          } @else if (data.status==='CANCELLED') {
                            <span>Cancelled</span>
                          } @else if (data.status==='FAILED') {
                            <span>Failed</span>
                          } @else if (data.status==='TOO_MANY_ATTEMPT') {
                            <span>Too Many Attempts</span>
                          } @else {
                            <span>Success</span>
                          }
                        </div>
                        <div class="dh__step-dot"></div>
                        @if (data.completedAt) {
                          <div class="dh__step-time">
                            <span class="dh__step-time--strong">{{ data.completedAt | date: dateFormat }}</span>
                            @if (data.status==='CANCELLED' && data.cancelledBy) {
                              <span class="dh__meta-chip dh__meta-chip--block" ngbTooltip="Cancelled By">
                                <i class="fa fa-user" aria-hidden="true"></i>
                                {{ data.cancelledBy }}
                              </span>
                            }
                          </div>
                        }
                      </li>
                    </ul>

                    @if (data.errorCode || data.remark) {
                      <div class="dh__notes">
                        @if (data.errorCode && data.status !== 'SUCCESS') {
                          <p class="dh__note">
                            <span class="dh__note-label">Error:</span>
                            <span class="dh__note-error">
                              {{ failStatus[data.errorCode] ? failStatus[data.errorCode] : data.errorCode }}
                            </span>
                          </p>
                        }
                        @if (data.remark) {
                          <div class="dh__remark">
                            <span class="dh__note-label">Remark:</span>
                            <div class="dh__remark-body">
                              <span
                                class="dh__remark-text"
                                [class.dh__remark-text--error]="data.status !== 'SUCCESS'"
                                [title]="data.remark">{{ data.remark }}</span>
                              @if (isRemarkTruncated(data.remark)) {
                                <button
                                  type="button"
                                  class="dh__remark-download"
                                  (click)="downloadRemark(data.remark)"
                                  title="Download full remark"
                                  aria-label="Download full remark">
                                  <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </article>
                }

                @if (loadmore) {
                  <div class="dh__load-more">
                    <button type="button" class="dh__load-more-btn" (click)="loadMoreActivity()">
                      Load more
                    </button>
                  </div>
                }
              </div>
            }

            @if (!deviceHistoryView.length && !isLoading) {
              <div class="dh__empty">
                <i class="fa fa-history" aria-hidden="true"></i>
                <span>No history available for this device.</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
